import React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { isEmpty } from "lodash";

import { ArticleCardsProps } from "~/bff/components/ArticleCards";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

export const ArticleCards = (props: ArticleCardsProps): React.ReactNode => {
  const { articles, testAutomationId = "article-cards" } = props;

  if (isEmpty(articles)) {
    return null;
  }

  return (
    <Box
      sx={{ mb: { xs: 6.5, sm: 8 } }}
      {...getTestAutomationProps(testAutomationId)}
      id={testAutomationId ?? ""}
    >
      <Container>
        <Grid
          container
          sx={{
            justifyContent: "center",
          }}
        >
          {articles?.map((article, index) => (
            <Grid
              key={index} //NOSONAR ignored temporarily in scope of MUI update whose changes are not related to array keys
              size={{
                xs: 12,
                sm: 6,
              }}
            >
              {article as React.ReactNode}
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
